import APP from 'src/main.js'
import Investment from './Investment'

class AccountInvestment extends Investment {
  get account(){
    return this.constructor.employeeStore.accountsById.get(this.account_id)
  }
  get name(){
    if(this.account){
      return this.account.name
    } else {
      return null
    }
  }
}

export default AccountInvestment
